import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP (see metadata.md grounding note for file mapping).

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "One developer. Two months. A multi-tenant enterprise SaaS, in production, serving real queries." },
];

export const STACK: ScriptLine[] = [
  { scene: "stack", fromSec: 0.4, holdSec: 6.5, caption: "Next.js, Supabase Postgres with pgvector, Upstash Redis, OpenRouter for the LLM and embeddings." },
  { scene: "stack", fromSec: 7.2, holdSec: 6.3, caption: "Frontend on a budget Dokploy VPS, OCR service on Railway. Total infra: about twenty dollars a month." },
];

export const CHAT: ScriptLine[] = [
  { scene: "chat", fromSec: 0.4, holdSec: 6, caption: "It's an AI chat over your codebase and docs — but Sources-Only by default, so it answers only from what you indexed." },
  { scene: "chat", fromSec: 6.8, holdSec: 7.5, caption: "Every query runs a 7-stage pipeline: classify, rewrite, hybrid search, merge, then stream the answer with a coverage grader." },
];

export const CITATIONS: ScriptLine[] = [
  { scene: "citations", fromSec: 0.4, holdSec: 6, caption: "The whole point is the citation panel. Every claim links back to a real source chunk." },
  { scene: "citations", fromSec: 6.8, holdSec: 6.5, caption: "File name, the relevance score, and the exact passage — verification is one click away." },
  { scene: "citations", fromSec: 13.5, holdSec: 4.3, caption: "It's not the model making things up. It's traceable, every time." },
];

export const TENANT: ScriptLine[] = [
  { scene: "tenant", fromSec: 0.4, holdSec: 6, caption: "Multi-tenant means tenants can't see each other's data — and it's enforced in the database, not just the app." },
  { scene: "tenant", fromSec: 6.8, holdSec: 7, caption: "Every chunk carries a tenant_id; the search function filters on it. The query literally can't return another tenant's rows." },
];

export const MCP: ScriptLine[] = [
  { scene: "mcp", fromSec: 0.4, holdSec: 6.5, caption: "Same knowledge base is also an MCP server — so Cursor, Claude Code, or any MCP client can query it from your IDE." },
  { scene: "mcp", fromSec: 7.2, holdSec: 7, caption: "Four tools: query_eakc, list_sources, get_document, and a Graphify graph_query for structural questions." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 5.5, caption: "So here's the scoreboard. Grounded chat, citations, multi-tenant isolation, an MCP server." },
  { scene: "payoff", fromSec: 6.2, holdSec: 6.5, caption: "All of it solo, on a twenty-dollar VPS — not a forty-person platform team." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "The product is the easy part to show. The hard part is the retrieval underneath it." },
  { scene: "outro", fromSec: 5.8, holdSec: 4.2, caption: "Next: how my AI knows it already said that — and refuses to repeat itself." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
